module.exports = __webpack_public_path__ + "static/img/news-1.b464766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news-1.png
// module id = 303m
// module chunks = 1